import { render, staticRenderFns } from "./Backups.vue?vue&type=template&id=62960d12&scoped=true&"
import script from "./Backups.vue?vue&type=script&lang=js&"
export * from "./Backups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62960d12",
  null
  
)

export default component.exports